export class ExportType {
    private _type: string = 'text/csv';
    private _humanFriendlyType: string = 'csv';
    private _api_endpoint: string;
    private _name: string;

    constructor(_api_endpoint: string, name: string) {
        this._api_endpoint = _api_endpoint;
        this._name = name;
    }

    public setType(type: string, humanFriendlyType: string): ExportType {
        this._type = type;
        this._humanFriendlyType = humanFriendlyType;
        return this;
    }

    public getType(): string {
        return this._type;
    }

    public getHumanFriendlyType(): string {
        return this._humanFriendlyType;
    }

    public getApiEndpoint(): string {
        return this._api_endpoint;
    }

    public getName(): string {
        return this._name;
    }
}
